import Vue from 'vue'
import { api } from "../../services/Api.js";


export function send_pushnote({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token;
    console.log("SPN",payload)
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    //console.log("**** send_pushnote payload:",payload)
    // make api call
    return api
      .post(school,"send_pushnote.php",payload)
      .then( result =>{ 
       // push note sent
       //console.log("**** send_pushnote result:",result)
       return result;
      })
      .catch( error => {
        Vue.$toaster.toast("store: error sending pushnotification: "+error);
        return error;
      })

   

  }